import { Flex, Text, Box } from "@chakra-ui/react";
import { BackIcon } from "./icons";
import CurrencySwitch from "./CurrencySwitch";
import { useUserInfo } from "@/context/UserInfo";

const TitleHeader = ({
  title,
  color = "#fff",
  showSwitch = false,
  onBack,
  rightComponent,
}: {
  title: string;
  color?: string;
  showSwitch?: boolean;
  onBack?: () => void;
  rightComponent?: React.ReactNode;
}) => {
  const { showUsd, handleSwitchCurrency } = useUserInfo();
  return (
    <Flex
      sx={{
        position: "relative",
        width: "100%",
      }}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <BackIcon
        style={{
          width: "18px",
          color: color,
          position: "absolute",
          top: "50%",
          left: "0",
          transform: "translateY(-50%)",
        }}
        onClick={onBack}
      />
      <Text
        sx={{ color, fontSize: "24px", fontStyle: "normal", fontWeight: 700 }}
      >
        {title}
      </Text>
      {showSwitch && (
        <CurrencySwitch
          onChange={() => {
            handleSwitchCurrency();
          }}
          checked={showUsd}
          sx={{
            position: "absolute",
            right: "0",
            top: "50%",
            transform: "translateY(-50%)",
          }}
        />
      )}
      {rightComponent && !showSwitch && (
        <Box
          sx={{
            position: "absolute",
            right: "0",
            top: "50%",
            transform: "translateY(-50%)",
          }}
        >
          {rightComponent}
        </Box>
      )}
    </Flex>
  );
};

export default TitleHeader;
